module.exports = __webpack_public_path__ + "img/celer-small-light.e57af849.svg";